import { toApiUrl } from '../../utils/apiBase';
import { useContext, useState } from 'react';
import { GlobalContext } from '../../context/GlobalContext';
import { unsafeAPI } from '../../hooks/api';
import { Dialog } from '../../components/Dialog';
import { DatePicker } from '../../shadcn/DatePicker';
import Input from '../../components/Input';
import { Button } from '../../shadcn/Button';

export default function RegisterPaymentManually() {
	const { userData, internalCountry } = useContext(GlobalContext);

	const [dialogMessage, setDialogMessage] = useState('');
	const [loading, setLoading] = useState(false);
	const [paymentObjectId, setPaymentObjectId] = useState('');
	const [paymentAmount, setPaymentAmount] = useState('');
	const [selectedDate, setSelectedDate] = useState('');
	const [bankId, setBankId] = useState('');
	const [reference, setReference] = useState('');

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		if (!paymentObjectId || !paymentAmount || !selectedDate) {
			setDialogMessage('Por favor rellene todos los datos');
			return;
		}

		setLoading(true);

		try {
			const data = {
				payment_object_id: paymentObjectId,
				payment_amount: parseFloat(paymentAmount),
				date: selectedDate,
				bank_id: bankId,
				reference: reference,
			};

			const response = await unsafeAPI(
				'POST',
				toApiUrl('add_payment/'),
				data,
				userData,
				internalCountry.get()
			);

			if (response?.success === true) {
				setDialogMessage('Pago registrado correctamente.');
				setPaymentObjectId('');
				setPaymentAmount('');
				setSelectedDate('');
				setBankId('');
				setReference('');
			} else {
				setDialogMessage(response?.status?.length ? 'Error: ' + response.status : 'Ocurrio un problema intente mas tarde.');
			}
		} catch (err: any) {
			setDialogMessage('Error: ' + err.message);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="mx-auto w-full max-w-7xl p-4 md:p-[1.25rem]">
			{dialogMessage && (
				<Dialog onClose={() => setDialogMessage('')} title="">
					<p>{dialogMessage}</p>
				</Dialog>
			)}
			<form className="space-y-4" onSubmit={handleSubmit}>
				<div className="space-y-0 xl:text-center">
					<h2 className="text-2xl font-semibold text-neutral-100">Registro manual de pago</h2>
					<p className="text-sm text-neutral-400">Ingrese los datos del pago a registrar</p>
				</div>

				<div className="flex max-w-4xl flex-col gap-4 pt-3 md:flex-row md:gap-2 xl:mx-auto">
					<DatePicker
						containerClassName="w-full"
						floatingLabel={'Fecha'}
						onDateChange={(value) => setSelectedDate(value || '')}
					/>

					<Input
						containerClassName="w-full"
						placeholder={'Ingresar'}
						floatingLabel={'ID del pago'}
						value={paymentObjectId}
						onChange={(value) => setPaymentObjectId(value)}
						allowedChars={'alphanumeric'}
					/>

					<Input
						containerClassName="w-full"
						placeholder={'Ingresar'}
						floatingLabel={'Monto'}
						value={paymentAmount}
						onChange={(value) => setPaymentAmount(value)}
						allowedChars={'numeric'}
					/>
				</div>

				<div className="flex max-w-4xl flex-col gap-4 md:flex-row md:gap-2 xl:mx-auto">
					<Input
						containerClassName="w-full"
						placeholder={'Ingresar'}
						floatingLabel={'ID del banco'}
						value={bankId}
						onChange={(value) => setBankId(value)}
					/>

					<Input
						containerClassName="w-full"
						placeholder={'Ingresar'}
						floatingLabel={'Referencia'}
						value={reference}
						onChange={(value) => setReference(value)}
					/>

					<div className="ml-0 flex shrink-0 justify-end md:ml-4">
						<Button loading={loading} variant="primary" className="!h-12 w-fit" type="submit">
							Registrar
						</Button>
					</div>
				</div>
			</form>
		</div>
	);
}
